.field {
  margin-bottom: var(--sp-5);
}

.row {
  display: flex;
  gap: var(--sp-4);
}

.row > .field {
  flex: 1 1 0;
  min-width: 0;
}

.warning {
  margin-top: var(--sp-2);
  color: var(--warn);
  font-size: var(--fs-sm);
}

.hint {
  margin-top: var(--sp-2);
  color: var(--text-3);
  font-size: var(--fs-sm);
}

.moneyRow {
  display: flex;
  gap: var(--sp-3);
}

.moneyAmount {
  flex: 1 1 auto;
}

.moneyCurrency {
  flex: 0 0 84px;
}

.checkboxLabel {
  display: flex;
  align-items: center;
  gap: var(--sp-3);
  color: var(--text-2);
  font-size: var(--fs-md);
  cursor: pointer;
}

.checkboxLabel input {
  width: 16px;
  height: 16px;
}

.stepper {
  display: flex;
  align-items: center;
  gap: var(--sp-2);
}

.stepperBtn {
  flex: 0 0 auto;
  width: 30px;
  height: 30px;
  padding: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: var(--fs-lg);
  line-height: 1;
}

.stepperInput {
  width: 64px;
  text-align: center;
}
